interface Props {
  text: string;
}
const ContactUsSubtitle: React.FC<Props> = ({ text }) => {
  return <div className="contact-us-subtitle">{text}</div>;
};

export default ContactUsSubtitle;
